export default function MenuDivider() {
  return (
    <li className="divider"></li>
  )
}
